export { Column } from './column';
export { Table } from './table';
export { TableConfig } from './table-config.interface';
